// extracted by mini-css-extract-plugin
export var icon = "_a4-3";
export var subtitle = "_a4-2";
export var title = "_a4-1";
export var value = "_a4-0";